import { getDayBefore, getMinsBefore, getTodayDate } from 'src/utils/utilities';
import axios from './index';

export const getTransactionRequest = (values) =>
  axios.get(
    `/v1/admins/get/transactions/-/${values?.vendorID || '-'}/-/${values?.routeID || '-'}/${
      values?.from || getMinsBefore(5)
    }/${values?.to || getTodayDate()}/-/-`
  );
